import 'select2';
import { SearchService } from './SearchService';

const select2Config = {
	allowClear: false,
	minimumResultsForSearch: Infinity,
};

export class FacetFiltersSelect<TFacets extends string, ISearchResult> {
	protected _facetName;
	protected _facets;
	protected _searchService;
	protected _element: JQuery<HTMLElement>;
	protected _select: JQuery<HTMLElement>;

	protected _topResultsCount: number | null = null;

	public constructor(
		element: JQuery<HTMLElement>,
		searchService: SearchService<TFacets, ISearchResult>,
		facetName: TFacets,
		facets: Map<string, string>,
	) {
		this._element = element;
		this._facetName = facetName;
		this._facets = facets;
		this._searchService = searchService;
		this._select = $('select', this._element);

		this._select.select2(select2Config);

		this._select.on('change', () => {
			this.handleChange();
		});

		this.render();

		searchService.addResultsListener(() => this.render());
	}

	protected render() {
		if (this._facets) {
			let nbHits = 0;
			// Create the facets
			this._facets.forEach((facetLabel, singleFacet) => {
				const selected = this.isActiveFilter(singleFacet);
				let count = 0;
				const facetCount = this._searchService.facetCounts;
				if (
					facetCount &&
					this._facetName in facetCount &&
					singleFacet in facetCount[this._facetName]
				) {
					count = facetCount[this._facetName][singleFacet];
				}

				const disabled = count === 0;

				// Remove any past options
				$(`option[value="${singleFacet}"]`, this._element).remove();

				const newOption = new Option(
					`${facetLabel} (${count})`,
					singleFacet,
					false,
					selected,
				);
				newOption.disabled = disabled;

				this._select.append(newOption);
			});

			if (this._searchService.algoliaResults) {
				nbHits = this._searchService.algoliaResults.nbHits;
			}

			this._select.trigger('change.select2');
		}
	}

	protected isActiveFilter(filterValue: string) {
		if (
			this._searchService.searchParams.facetsData &&
			this._facetName in this._searchService.searchParams.facetsData &&
			this._searchService.searchParams.facetsData[
				this._facetName
			].indexOf(filterValue) >= 0
		) {
			return true;
		}

		return false;
	}

	protected handleChange() {
		const facetValue = this._select.val();

		const newSearchParams = this._searchService.searchParams;
		if (!newSearchParams.facetsData) {
			newSearchParams.facetsData = {} as any;
		}

		if (facetValue) {
			newSearchParams.facetsData[this._facetName] =
				typeof facetValue === 'string'
					? [facetValue]
					: (facetValue as string[]);
		} else {
			newSearchParams.facetsData[this._facetName] = [];
		}

		this._searchService.searchParams = newSearchParams;
	}
}



// WEBPACK FOOTER //
// ./scripts/algolia/FacetFiltersSelect.ts